import { useEffect, useRef, useState } from "react";
import styles from "./criteoSpotLightAdvert.scss";
import useCriteoSpotLight from "../../hooks/useCriteoSpotLight";
import {
  callOnLoadBeacon,
  callOnViewBeacon,
} from "../../../common/CriteoAdvertsForRecs";
import { createPortal } from "react-dom";
const CriteoSpotLightAdvert = () => {
  const [targetPortalElement, setTargetPortalElement] = useState();
  const targetSpotLightElement = useRef();
  const spotLightData = useCriteoSpotLight();

  const fireOnClickBeacon = (event, onClickBeaconUrl, redirectUrl) => {
    event.preventDefault();
    navigator?.sendBeacon?.(onClickBeaconUrl);
    window.location.href = redirectUrl;
  };

  useEffect(() => {
    if (spotLightData) {
      callOnLoadBeacon(spotLightData.OnLoadBeacon);
      callOnViewBeacon(targetSpotLightElement, spotLightData.OnViewBeacon);
    }
    setTargetPortalElement(document.getElementById("div-gpt-ad-pdp-1"));
  }, [spotLightData]);

  if (!spotLightData || !targetPortalElement) return null;

  const {
    dsa_url,
    rendering: {
      background_image,
      background_image_alt_text,
      legal_text,
      mobile_background_image,
      mobile_background_image_alt_text,
      redirect_url,
    },
  } = spotLightData;

  return createPortal(
    <div className={styles["criteo-spotLight-container"]}>
      <div
        className={styles["spotlight-image-info-container"]}
        ref={targetSpotLightElement}
      >
        <a
          href={`https:${dsa_url}`}
          aria-label={legal_text}
          title={legal_text}
          className={styles["info-container"]}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className={styles["info-icon"]} aria-hidden="true"></span>
        </a>
        <picture>
          <source media="(min-width: 720px)" srcSet={mobile_background_image} />
          <img
            src={background_image}
            alt={background_image_alt_text || mobile_background_image_alt_text}
            role="link"
            tabIndex={0}
            onClick={(event) =>
              fireOnClickBeacon(
                event,
                spotLightData.OnClickBeacon,
                redirect_url,
              )
            }
          />
        </picture>
      </div>
    </div>,
    targetPortalElement,
  );
};

export default CriteoSpotLightAdvert;
